export const NEWSLETTER_TEMPLATES = [
  {
    id: "weekly-wellness",
    name: "Weekly Wellness Update",
    description: "Weekly wellness tips, highlights, and community news",
    content: `<h1>Weekly ME.WELL Wellness Update</h1>
<p><em>Your weekly dose of mind-emotional wellness from SMAHOO</em></p>
<hr>
<h2>This Week's Wellness Focus</h2>
<p>Write about this week's theme here. What should members focus on? Share insights, tips, or guided reflections.</p>
<h2>Community Highlights</h2>
<ul>
<li>Highlight a community achievement or story</li>
<li>Share an inspiring member moment</li>
<li>Mention upcoming community events</li>
</ul>
<h2>Quick Wellness Tip</h2>
<blockquote>Share a brief, actionable wellness tip that readers can apply today.</blockquote>
<h2>Upcoming Events</h2>
<p>List any upcoming sessions, retreats, or special events here.</p>
<hr>
<p><em>Did You SMAHoo Today? Remember to check in with your Mind-SPA daily.</em></p>`,
  },
  {
    id: "event-announcement",
    name: "Event Announcement",
    description: "Announce retreats, workshops, sessions, or special events",
    content: `<h1>Special Event Announcement</h1>
<p><strong>You're Invited!</strong></p>
<hr>
<h2>Event Name</h2>
<p>Describe the event here. What will participants experience? What's the focus?</p>
<h2>Event Details</h2>
<ul>
<li><strong>Date:</strong> [Date]</li>
<li><strong>Time:</strong> [Time]</li>
<li><strong>Location:</strong> [Virtual/In-Person Location]</li>
<li><strong>Who It's For:</strong> [Target audience]</li>
</ul>
<h2>What You'll Gain</h2>
<ol>
<li>First benefit or takeaway</li>
<li>Second benefit or takeaway</li>
<li>Third benefit or takeaway</li>
</ol>
<h2>How to Register</h2>
<p>Describe registration steps or include a link to book.</p>
<blockquote>Spaces are limited. Reserve your spot today!</blockquote>`,
  },
  {
    id: "new-feature",
    name: "New Feature Launch",
    description: "Introduce new app features, tools, or improvements",
    content: `<h1>New Feature: [Feature Name]</h1>
<p><strong>We're excited to announce something new in your ME.WELL experience!</strong></p>
<hr>
<h2>What's New?</h2>
<p>Describe the new feature. What does it do? How does it enhance the wellness journey?</p>
<h2>How to Use It</h2>
<ol>
<li>Step one — how to access the feature</li>
<li>Step two — what to do first</li>
<li>Step three — how to get the most from it</li>
</ol>
<h2>Why We Built This</h2>
<p>Share the story behind this feature. How does it serve the ME.WELL mission?</p>
<blockquote>Your feedback shapes what we build next. Let us know what you think!</blockquote>`,
  },
  {
    id: "mind-spa-digest",
    name: "Mind-SPA Session Digest",
    description: "Summary of recent Mind-SPA sessions with key takeaways",
    content: `<h1>Mind-SPA Session Digest</h1>
<p><em>Key takeaways from recent ME.WELL sessions</em></p>
<hr>
<h2>Session Recap: [Session Title]</h2>
<p>Summarize what was covered in the recent session. What were the key themes?</p>
<h3>Key Takeaways</h3>
<ul>
<li>First key insight from the session</li>
<li>Second key insight</li>
<li>Third key insight</li>
</ul>
<h3>Reflection Exercise</h3>
<blockquote>Take 5 minutes to reflect: How does this session's theme apply to your daily life? Write down one thing you'll do differently this week.</blockquote>
<h2>Recommended Next Steps</h2>
<ol>
<li>Practice the guided exercise from the session</li>
<li>Share your reflections in the community forum</li>
<li>Book your next session to continue the journey</li>
</ol>
<hr>
<p><em>The ME.WELL Mind-SPA — Where healing meets purpose.</em></p>`,
  },
  {
    id: "community-spotlight",
    name: "Community Spotlight",
    description: "Highlight community members, stories, and achievements",
    content: `<h1>Community Spotlight</h1>
<p><em>Celebrating the stories and journeys within our Global.VILLAGE</em></p>
<hr>
<h2>Featured Member Story</h2>
<p>Share a community member's wellness journey (with their permission). What challenges did they face? How has ME.WELL helped?</p>
<h2>Community Milestones</h2>
<ul>
<li>Total SMAHOO Coins earned this month: [number]</li>
<li>New members who joined: [number]</li>
<li>Sessions completed: [number]</li>
</ul>
<h2>Words of Encouragement</h2>
<blockquote>Every step forward counts. Your presence in this community makes a difference — not just for yourself, but for everyone around you.</blockquote>
<h2>Get Involved</h2>
<p>Share your own story, mentor a new member, or start a discussion in the forum. Your voice matters.</p>`,
  },
];
